import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LanguageService from "../api/language";
import { getUrlVars } from "../utils/systemInfo";
import Swal from "sweetalert2";
import TemplateAddEdit from "../common/Layout/templatePages/templateAddEdit";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import handleNavigate from "../common/customFunctions/handleNavigate";

const breadcrumbs = [
    { id: 0, name: "Home", href: "./" },
    { id: 1, name: "Language Api", href: "languageApi" },
    { id: 2, name: "Add/Edit Translations", href: `addEditTranslations` }
];

export default function AddEditTranslations() {
    const organziation = useSelector(({ organziation }) => organziation);
    const apiKey = organziation?.api_key_list?.[0]?.key;
    const language_dictionary_id = getUrlVars()["language_dictionary_id"] || "";
    const navigate = useNavigate();

    const [item, setItem] = useState({
        variable_name: "",
        sensitive: "true"
    });

    const [languages, setLanguages] = useState([]);
    const [translations, setTranslations] = useState({});

    useEffect(() => {
        if (!apiKey) return;
        LanguageService.GetLanguageProfile("", "", "", "active", apiKey).then((res) => {
            setLanguages(res.language_profile || []);
        });
    }, [apiKey]);

    useEffect(() => {
        if (!apiKey || !language_dictionary_id) return;
        LanguageService.GetLanguageDictionary(language_dictionary_id, "active", apiKey).then((res) => {
            console.log(res);
            const dict = res.language_dictionary?.[0];
            if (dict) {
                const trans = {};
                (dict.translation || []).forEach((item) => {
                    trans[item.code] = item.value;
                });
                setTranslations(trans);
                setItem({
                    variable_name: dict.variable_name || "",
                    sensitive: dict.sensitive === true ? "true" : dict.sensitive === false ? "false" : dict.sensitive ?? "true"
                });
            }
        });
    }, [apiKey, language_dictionary_id]);

    const handleTranslationChange = (code, value) => {
        setTranslations((prev) => ({ ...prev, [code]: value }));
    };

    const handleSave = async (data) => {
        const translationArr = languages.map((lang) => ({
            code: lang.code?.toLowerCase().replaceAll(" ", ""),
            value: translations[lang.code?.toLowerCase().replaceAll(" ", "")] || ""
        }));
        try {
            const res = await LanguageService.SetLanguageDictionary(language_dictionary_id, data.variable_name, data.sensitive, translationArr, "active", apiKey);
            if (res.success) {
                Swal.fire({
                    icon: "success",
                    title: "Saved!",
                    timer: 1000,
                    background: "var(--background-color)",
                    showConfirmButton: false
                }).then(() => {
                    handleNavigate(event, navigate, `/languageApi`);
                });
            }
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Save Failed",
                text: err?.toString() || "Unknown error"
            });
        }
    };

    const handleDelete = async () => {
        const result = await Swal.fire({
            icon: "warning",
            title: "Are you sure?",
            text: "This will remove the translation entry.",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                await LanguageService.SetLanguageDictionary(
                    language_dictionary_id,
                    item.variable_name,
                    item.sensitive,
                    Object.entries(translations).map(([code, value]) => ({ code, value })),
                    "removed",
                    apiKey
                );
                Swal.fire({
                    icon: "success",
                    title: "Deleted!",
                    text: "The translation was removed.",
                    timer: 1000,
                    showConfirmButton: false,
                }).then(() => {
                    handleNavigate(event, navigate, `/languageApi`);
                });
            } catch (err) {
                Swal.fire({
                    icon: "error",
                    title: "Delete Failed",
                    text: err?.toString() || "Unknown error"
                });
            }
        }
    };

    const translationsGrid = (
        <Box sx={{ mt: 2 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
                Translations
            </Typography>
            <Grid container spacing={2}>
                {languages.map((lang) => {
                    const code = lang.code?.toLowerCase().replaceAll(" ", "");
                    return (
                        <Grid item xs={12} md={6} key={code}>
                            <TextField label={lang.name} value={translations[code] || ""} onChange={(e) => handleTranslationChange(code, e.target.value)} fullWidth id={`language-${code}-code`} variant="outlined" margin="normal" />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );

    const dataToShow = [
        { key: "variable_name", label: "Variable Name", isRequired: true, type: "text" },
        { key: "sensitive", label: "Sensitive", isRequired: true, type: "boolean" }
    ];

    return <TemplateAddEdit breadcrumbs={breadcrumbs} title="Add/Edit Translations" gridCol={2} dataToShow={dataToShow} item={item} onSaveClick={handleSave} additionalData={translationsGrid} showDelete={!!language_dictionary_id} onDeleteClick={handleDelete} />;
}
